export enum DialogAction {
    Refuse = 'Refuse',
    Apply = 'Apply',
    Accept = 'Accept',
}
